<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist
                @help="help"
                @add="add"
                @search="search"
                @reflash="reflash"
                @exps="exp"
                @del="delall"
                ref="SetBtn"
        ></buttonlist>
        <!-- 功能按钮 -->
        <!-- 表格 -->
        <div style="margin-top: 2px">
            <el-button type="primary" size="mini" @click="expdetail('有')" :disabled="!btn.export">{{$t('getapi[6862]')}}</el-button>
            <el-button type="primary" size="mini" @click="expdetail('无')" :disabled="!btn.export">{{$t('getapi[6863]')}}</el-button>
            <!--<el-button type="primary" size="mini" @click="handleSpeak('开饭,再次开饭')">{{$t('getapi[6863]')}}</el-button>-->
        </div>
        <el-table
                id="xpane-0"
                :data="datajson"
                v-loading="loading"
                :highlight-current-row="false"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                header-row-class-name="headerclass"
                :height="tableHeight"
                @cell-dblclick="editInfo"
                tab-click="selectInfo(0)"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Exclusively_ID" label="ID" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="WORKPROC_CODE" :label="$t('getapi[3330]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="WORKPROC_NAME" :label="$t('getapi[3331]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="OperationCode" :label="$t('getapi[8092]')"></el-table-column>
            <!-- <el-table-column show-overflow-tooltip prop="WORKPROC_SHORTNAME"
                             :label="$t('getapi[574]')"></el-table-column> -->
            <!--<el-table-column show-overflow-tooltip prop="enable_flag" :label="$t('getapi[552]')">
                <template slot-scope="scope">
                    &lt;!&ndash;<fragment v-if="scope.row.enable_flag == '1'"><el-switch :value="true"></el-switch></fragment>
                    <fragment v-else><el-switch :value="false"></el-switch></fragment>&ndash;&gt;
                    <span>{{scope.row.enable_flag == 1 ? '有效' : '无效'}}</span>
                    &lt;!&ndash;<el-checkbox v-model="scope.row.enable_flag" true-label="1" false-label="0" :disabled="true"></el-checkbox>&ndash;&gt;
                </template>
            </el-table-column>-->
            <el-table-column show-overflow-tooltip prop="WI_FilePath" :label="$t('getapi[6864]')">
            </el-table-column>
            <el-table-column prop="WIName" :label="$t('getapi[6865]')">
                <template scope="scope">
                    <span>{{ scope.row.WIName | lanchange}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="Need_Mould" :label="$t('getapi[6866]')">
                <template slot-scope="scope">
                   {{scope.row.Need_Mould == true?$t('getapi[2052]'):$t('getapi[2053]')}}
                </template>
            </el-table-column>
            <el-table-column prop="enable_flag_name" :label="$t('getapi[552]')">
                <template scope="scope">
                    <span>{{ scope.row.enable_flag_name | lanchange}}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="REMARK" :label="$t('getapi[143]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="OkCount" :label="$t('getapi[6867]')" align="right">
            </el-table-column>
            <el-table-column prop="NoCount" :label="$t('getapi[6868]')" align="right">
                <template slot-scope="scope">
                    <span style="text-decoration:underline" @click="getCarftDetail(scope.row.WORKPROC_NAME)">{{scope.row.NoCount}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="device_flag" :label="$t('getapi[12829]')">
                <template slot-scope="scope">
                    {{scope.row.device_flag == true?$t('getapi[2052]'):$t('getapi[2053]')}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="isadd_docnodename" :label="$t('getapi[12900]')"></el-table-column>
            <el-table-column prop="report_need_one" :label="$t('getapi[13181]')">
                <template scope="scope">
                    <span>{{ scope.row.report_need_one}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="report_need_two" :label="$t('getapi[13182]')">
                <template scope="scope">
                    <span>{{ scope.row.report_need_two}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="report_need_three" :label="$t('getapi[13183]')">
                <template scope="scope">
                    <span>{{ scope.row.report_need_three}}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="report_person" :label="$t('getapi[13184]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="workcenter_name" :label="$t('getapi[13352]')"></el-table-column>

            
            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="80">
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="edit(scope)" type="text" size="small">{{
                        $t('getapi[34]') }}
                    </el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[6109]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope)"
                            v-if="userData.Login_Code == 'boss'"
                    >
                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]')
                            }}
                        </el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <!-- 表格 -->
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="12">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[50, 100, 200, 300, 400]"
                    :page-size="PageSize"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </el-col>
            <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}
            </div>
        </el-row>
        <!-- 分页 -->
        <!-- 搜索弹框 -->
        <serce :isVisible="isVisible" queryData="ENGRoutingTypeViewInfo" ref="ser" @getser="serclick"></serce>
        <!--<el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[3653]')" width="30%" :close-on-click-modal="false">
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('getapi[2020]')">
                    <el-table :data="queryData" border height="400" size="mini" style="width: 100%;">
                        <el-table-column show-overflow-tooltip prop="Field_Show_Name" :label="$t('getapi[2021]')"
                                         width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip :label="$t('getapi[2022]')">
                            <template slot-scope="scope">
                                <input type="text" v-model="scope.row.query_Condition" style="border:none"/>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$t('getapi[2028]')">
                    <div style="min-height: 400px; line-height: 30px;" v-html="hleptext"></div>
                </el-tab-pane>
            </el-tabs>

            <span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="intidata">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>-->
        <!-- 搜索弹框 -->
        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[34]')" width="30%" :close-on-click-modal="false">
           
            <el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[3330]')}}</td>
					<td><el-input v-model="formInline._workproc_code" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[3331]')}}</td>
					<td><el-input v-model="formInline._workproc_name" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
                    <td>{{$t('getapi[143]')}}</td>
					<td><el-input v-model="formInline._remark" type="text" size="mini" ></el-input></td>
					<td>{{$t('getapi[552]')}}</td>
					<td>
						<el-select filterable v-model="formInline._enable_flag"  size="mini">
							<el-option :label="$t('getapi[1170]')" :value="1"></el-option>
                            <el-option :label="$t('getapi[1171]')" :value="0"></el-option>
						</el-select>
					</td>
				</tr>
				<tr>
					<td>{{$t('getapi[6865]')}}</td>
					<td>
						<el-select filterable v-model="formInline._wi"  size="mini">
							<el-option :label="$t('getapi[2052]')" :value=1></el-option>
                            <el-option :label="$t('getapi[2053]')" :value=0></el-option>
						</el-select>
					</td>
					<td>{{$t('getapi[6866]')}}</td>
					<td>
						<el-select filterable v-model="formInline._Need_mould"  size="mini">
							<el-option :label="$t('getapi[2052]')" :value=true></el-option>
                            <el-option :label="$t('getapi[2053]')" :value=false></el-option>
						</el-select>
					</td>
				</tr>
				<tr>
					<td>{{$t('getapi[6864]')}}</td>
					<td><el-input v-model="formInline._wi_filepath" type="text" size="mini"></el-input></td>
                    <td>{{$t('getapi[8092]')}}</td>
					<td><el-input v-model="formInline._operationcode" type="text" size="mini" ></el-input></td>
				</tr>
                <tr>
                    <td>{{$t('getapi[12829]')}}</td>
                    <td><el-checkbox v-model="formInline._device_flag"></el-checkbox></td>
                    <td>{{$t('getapi[12900]')}}</td>
                    <td><el-checkbox  v-model="formInline._isadd_docnode" :true-label=1
                                                    :false-label=0></el-checkbox></td>
                </tr>  
                <tr>
                    <td>{{$t('getapi[13181]')}}</td>
					<td><el-input v-model="formInline._report_need_one" type="text" size="mini"></el-input></td>
                    <td>{{$t('getapi[13182]')}}</td>
                    <td><el-input v-model="formInline._report_need_two" type="text" size="mini"></el-input></td>
                </tr>    
                <tr>
                    <td>{{$t('getapi[13183]')}}</td>
                    <td><el-input v-model="formInline._report_need_three" type="text" size="mini"></el-input></td>
                    <td>{{$t('getapi[13184]')}}</td>
					<td>
                        <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
							<el-input
									v-model="formInline._report_person"
							>
								<i class="el-icon-edit el-input__icon" slot="suffix" @click="seluserinfo()"></i>
							</el-input>
						</routejump>
                        <!-- <el-input v-model="formInline._report_person" type="text" size="mini"></el-input> -->
                    </td>
                </tr>     
                <tr>
                    <td>{{$t('getapi[13352]')}}</td>
					<td>
                        <routejump :urlNo="15" :isDialog="2" @callback="beforeRoutJump">
							<el-input
									v-model="formInline._workcenter_name"
							>
								<i class="el-icon-edit el-input__icon" slot="suffix" @click="selworkcenterinfo()"></i>
							</el-input>
						</routejump>
                        <el-input v-model="formInline._workcenter_id" v-if="false" type="text" size="mini"></el-input>
                    </td>
                </tr>        
			</table>
			</div>
			<el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button size="small"  @click="editvisi = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small"  type="primary" @click="sava" :loading="loading" :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        <!-- 编辑弹框 -->
        <selector
                :isVisible="uservisible"
                :isBatch="false"
                :selectType="0"
                :isSplitPage="true"
                :postUrl="'/Basic/Popup/GetQualityUsersPopuDataList'"
                @callback="getuserinfo"
                ref="userinfo"
        ></selector>
         <!-- 编辑弹框 -->
         <selector
                :isVisible="workcentervisible"
                :isBatch="false"
                :selectType="0"
                :isSplitPage="true"
                :postUrl="'/Basic/Items/GetEngWorkCenterPopupList'"
                @callback="getworkcenterinfo"
                ref="workcenterinfo"
        ></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    const synth = window.speechSynthesis;
    const msg = new SpeechSynthesisUtterance();
    export default {
        name: 'processt',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3- Common.reduceTableHeight3
            }
        },
        data() {
            return {
                userData:[],
                formInline: {
                    _exclusively_id: 0,
                    _workproc_code: '',
                    _workproc_name: '',
                    _workproc_shortname: '',
                    _remark: '',
                    _enable_flag: 0,
                    _operationcode:'',
                    _device_flag:false,
                    _isadd_docnode:0,
                    _report_need_one:'',
                    _report_need_two:'',
                    _report_need_three:'',
                    _report_person:'',
                    _workcenter_id:0,
                    _workcenter_name:'',
                },
                ids: '',
                showloading: '',
                isVisible: false,
                editvisi: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize:  this.$http.getPageSize('processt'),
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                dataSetDetail: {}, // 编辑页面数据详情
                queryData: [], // 查询数组
                selectIDData: '', // 选择的数据的ID集合
                selectData: [],
                tracetype: 0, //跟踪类别
                url: '', // 零件图路径
                isEdit: true, // 是否新增
                btn: {
                    del: false,
                    edit: false,
                    export: false
                },
                synth:null,
                msg:'',
                scrollTop:0,
                addoredit:0,
                uservisible:false,
                persontype:1,//1:负责人
                workcentervisible:false,
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
            //this.getqwlist();

        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            console.log('mounted');
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.intidata();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3084]"),this.$t("getapi[11]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                if (that.$limits.ReadOnlyRights('plv2', 26, 1)) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                //操作权
                let ilimits = that.$limits.UnOperationAuthority('plv2', 26, 1);
                // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                switch (ilimits) {
                    case 2:
                        that.btn.edit = true;
                        that.btn.del = false;
                        that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,export');
                        break;
                    case 3:
                        that.btn.edit = true;
                        that.btn.del = true;
                        that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,export');
                        break;
                    default:
                        that.$refs.SetBtn.SetButtonEnable('');
                        break;
                }
            },
            btnauthority(){
              let that = this
              that.btn.export = false
              if(that.selectData.length == 1){
                  that.btn.export = true
              }
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('processt',val)
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            seluserinfo(type) {
                let that = this
                this.uservisible = true;
                this.$refs.userinfo.clearInput(this.uservisible);
            },
            //负责人
            getuserinfo(data) {
                let that = this; 
                that.formInline._report_person = data.name+'('+data.userid+')';
            },
            selworkcenterinfo(type) {
                let that = this
                that.persontype = type
                this.workcentervisible = true;
                this.$refs.workcenterinfo.clearInput(this.workcentervisible);
            },
            //工作中心
            getworkcenterinfo(data) {
                let that = this; 
                that.formInline._workcenter_id= data.exclusively_id;
                that.formInline._workcenter_name= data.workcenter_name;
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldFormInline != JSON.stringify(that.formInline)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.isVisible = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.isVisible = false
                    callback(true)
                }
            },
            //编辑
            editInfo(row) {
                let that = this;
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                that.$http.urlpost('Basic/Items/RoutingTypeDataList', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 保存数据
            sava() {
                let that = this;
                that.loading = true;
                if (that.$limits.fnIsEmpty(that.formInline._workcenter_name)) {
                    that.formInline._workcenter_id= 0;
                }
               
                // let parm = new Array();
                // parm.push(that.formInline);
                // console.log(JSON.stringify(parm));
                that.$http.urlpost('Basic/Items/SaveRoutingType', that.formInline, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.intidata();
                        that.editvisi = false;
                    }
                    that.loading = false;
                });
                that.authority();
            },
            // 获取查询条件
            getqwlist() {
                let that = this;
                that.$http.urlpost('Basic/Items/WorkCenterQWList', {}, function (res) {
                    that.queryData = res.DataContent;
                });
            },
            // 编辑
            edit(jsd) {
                let that = this
                console.log(jsd);
                this.editvisi = true;
                that.addoredit = 1
                this.formInline = {
                    _exclusively_id: jsd.row.Exclusively_Id,
                    _workproc_code: jsd.row.WORKPROC_CODE,
                    _workproc_name: jsd.row.WORKPROC_NAME,
                    _workproc_shortname: jsd.row.WORKPROC_SHORTNAME,
                    _enable_flag: jsd.row.enable_flag,
                    _remark: jsd.row.REMARK,
                    _wi: jsd.row.WI,
                    _wi_filepath: jsd.row.WI_FilePath,
                    _Need_mould:jsd.row.Need_Mould,
                    _operationcode:jsd.row.OperationCode,
                    _device_flag:jsd.row.device_flag,
                    _isadd_docnode:jsd.row.isadd_docnode,
                    _report_need_one:jsd.row.report_need_one,
                    _report_need_two:jsd.row.report_need_two,
                    _report_need_three:jsd.row.report_need_three,
                    _report_person:jsd.row.report_person,
                    _workcenter_id:jsd.row.workcenter_id,
                    _workcenter_name:jsd.row.workcenter_name,
                };
                console.log(this.formInline);
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                that.selectData = []
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Exclusively_Id + ',';
                    that.selectData.push(val[i])
                }
                console.log(that.selectIDData);
                that.btnauthority()
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids
                };
                console.log(parm);
                that.$http.urlpost('Basic/Items/BatchDeleteRoutingType', parm, function (res) {
                    that.intidata();
                    that.$message.success(that.$t('getapi[659]'));
                });
            },
            // 删除
            del(jsd) {
                this.ids = jsd.row.Exclusively_Id + ',';
                this.delf();
            },
            //批量删除
            delall() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            // 新增
            add() {
                let that = this;
                that.addoredit = 0
                this.editvisi = true;
                that.formInline = {
                    _exclusively_id: 0,
                    _workproc_code: '',
                    _workproc_name: '',
                    _workproc_shortname: '',
                    _remark: '',
                    _enable_flag: 1,
                    _device_flag:false,
                    _isadd_docnode:0,
                    _report_need_one:'',
                    _report_need_two:'',
                    _report_need_three:'',
                    _report_person:'',
                    _workcenter_name:'',
                    _workcenter_id:0,
                }
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'ENGRoutingTypeViewInfo');
            },
            serclick(val) {
                this.queryData = val;
                this.intidata();
            },
            // 刷新
            reflash() {
                this.intidata();
            },
            //导出·
            exp() {
                let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: [],
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[1087]')
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                that.$http.urlpost('Basic/Items/RoutingType_ExportToExecl', parm, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            expdetail(flag) {
                let that = this
                let parm = {
                    workproc_name: that.selectData[0].WORKPROC_NAME,
                    flag: flag
                }
                that.$http.urlpost('/Basic/Items/ExportToExecl_RoutDetail', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            getCarftDetail(val){
                let that = this
                console.log(val)
                that.$store.commit('setSharedParams', {
                    key: val
                });
                let item = {
                    label: this.$t("getapi[65]"),
                    name: 'carftview',
                    path: '/carftview',
                    url: '/carftview',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/carftview'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            handleSpeak(text){
                msg.text = text;
                msg.lang = 'zh-CN';
                msg.volume = '1';
                msg.rate = 1;
                msg.pitch = 1;
                synth.speak(msg);
            },
            handleStop(e){
                msg.text = e;
                msg.lang = 'zh-CN';
                synth.cancel(msg);
            },

        }
    };
</script>

<style lang="scss" scoped>


table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
